import { types } from 'mobx-state-tree';
import { AddOnPlan } from './AddOnPlan';

export const Plan = types
  .model('Plan', {
    id: types.string,
    maxAutopurchases: types.maybe(types.number),
    maxListedItems: types.maybe(types.number),
    monthlyCost: types.maybe(types.number),
    monthlyCostUnreduced: types.maybe(types.number),
    annualCost: types.maybe(types.number),
    name: types.maybe(types.string),
    description: types.maybe(types.string),
    allowedAddOnPlans: types.optional(types.array(AddOnPlan), []),
    includesBIFMCatalog: types.maybe(types.number),
  })
  .views(self => ({
    get isHighlyRecommended() {
      // @todo maybe find a way to not have this hardcoded in the future
      return (
        self.id === 'plan_250' ||
        self.id === 'plan_5000' ||
        self.id === 'plan_250_nonapi' ||
        self.id === 'plan_5000_nonapi'
      );
    },
    get allowedAddOnPlansByTypeId() {
      return Object.fromEntries(
        self.allowedAddOnPlans.map(aop => {
          return [aop.typeId, { ...aop }];
        }),
      );
      // const byType = [];
      // for(let i = 0; i<self.allowedAddOnPlans.length; i++) {
      //   if(byType[self.allowedAddOnPlans[i].typeId]) {
      //     if(self.allowedAddOnPlans[i].isSelected !== ) {
      //       byType[self.allowedAddOnPlans[i].typeId]
      //     }
      //     byType[self.allowedAddOnPlans[i].typeId].variants.push({ ...self.allowedAddOnPlans[i] })
      //   } else {
      //     byType[self.allowedAddOnPlans[i].typeId] = { selectedIdx: 0, variants: [{ ...self.allowedAddOnPlans[i] }] };
      //   }
      // }
      // return byType;
    },
  }));
